import { Injectable } from '@angular/core';
import { DcTypes, Feature, TypedFeatureProperties } from '../../../../projects/client';
import { FeatureValueStrategy } from './feature-value-strategy.model';

@Injectable({ providedIn: 'root' })
export class BooleanValueStrategy implements FeatureValueStrategy {
  supports(
    feature: Feature<TypedFeatureProperties<boolean>, unknown>,
    propertyName: string
  ): boolean {
    const property = feature?.properties?.[propertyName];

    return property?.type === DcTypes.boolean && typeof property?.unit === 'undefined';
  }

  transformValue(
    feature: Feature<TypedFeatureProperties<boolean>, unknown>,
    propertyName: string
  ): string {
    return feature.properties?.[propertyName]?.value?.toString();
  }
}
